import { defineMessages } from "react-intl";

const messages = defineMessages({
    play: {
        id: "audio.play",
    },
});

export default messages;
